import LevelData from "../components/LevelData";
import { useParams, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;

const Level = () => {
  let { id } = useParams();
  const [technicName, setTechnicName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrl + `group_elements/${id}`);
        setTechnicName(response.data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [id]); // Effect se déclenche à chaque changement d'ID

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

    return (
      <div className="TechnicContainer">
        <div className="Title">
        <Link className="BackButton" to={{
                pathname: "/technic/",
            }}>
                <img src="./back.png" />
            </Link>
            
          <div className="TitleElement">
            {technicName.toUpperCase()}
          </div>
        </div>
        
        <div className="TechnicArea">
          <LevelData groupElementId={id}/>
        </div>

        {sessionStorage.getItem("role") == 1 ? (
            <Link className="AddButton" to={{
              pathname: "/technic/" + id + "/level_new",
          }}>
              <img src="./plus.png" />
          </Link>
          ) : (
            null
          )}
        
      </div>
      )
    };  
    export default Level;